import React from "react";
import arrowBack from '../../../../assets/images/Arrowback.svg';
import arrowRight from '../../../../assets/images/ArrowRight.svg';
import { Step } from "../../../../models/step";

interface FooterProps {
    currentStep: Step;
    formData: any;
    submitting: boolean;
    nextStep: Step | null;
    prevStep: Step | null;
    goToStep: (step: number | null) => void;
}

interface FooterState {

}

class Footer extends React.Component<FooterProps, FooterState> {
    private goToStep(e: any, stepNumber: number) {
        e.preventDefault();

        this.props.goToStep(stepNumber)
    }

    render(): React.ReactNode {
        const { prevStep, nextStep, submitting } = this.props;

        return (
            <>
                <footer className="footer">
                    <div className="row g-0">
                        <div
                            className={`col-6 d-flex align-items-center justify-content-between${prevStep && !submitting ? ' clickable' : ''}`}
                            onClick={prevStep && !submitting ? (e) => this.goToStep(e, prevStep.number) : undefined}
                        >
                            {prevStep && (
                                <>
                                    <div className={`btn-link btn-link-icon pager${submitting ? ' notClickable' : ''}`}>
                                        <img src={arrowBack} alt="icon" />
                                        <span>Vorige stap</span>
                                    </div>

                                    <span className="nav-link ms-auto">
                                        {prevStep.title}
                                        <span>
                                            <img src={require(`../../../../assets/images/${prevStep.icon}`).default} alt="Design" />
                                        </span>
                                    </span>
                                </>
                            )}
                        </div>

                        <div
                            className={`col-6 d-flex align-items-center justify-content-between${nextStep && !submitting ? ' clickable' : ''}`}
                            onClick={nextStep && !submitting ? (e) => this.goToStep(e, nextStep.number) : undefined}
                        >
                            {nextStep && (
                                <>
                                    <span className="nav-link me-auto">
                                        <span>
                                            <img src={require(`../../../../assets/images/${nextStep.icon}`).default} alt="Type" />
                                        </span>
                                        {nextStep.title}
                                    </span>

                                    <div className={`btn-link btn-link-icon pager${submitting ? ' notClickable' : ''}`}>
                                        <span>Volgende stap</span>
                                        <img src={arrowRight} alt="icon" />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </footer>
            </>
        )
    }
}

export default Footer;